import { withApiErrorResponse } from "../utils/apiError";

// Keep the envelope intact for callers that use header messages, but never let
// an application-level failure be mistaken for an HTTP success.
export const checkedInventoryResponse = (response) => {
  const data = response.data;
  const value = data?.body?.value ?? data?.body ?? data;
  const status = String(value?.status ?? "").toUpperCase();
  if ((data?.header?.code != null && Number(data.header.code) !== 600) ||
      data?.success === false || value?.success === false ||
      status === "FAILED" || status === "CANCELLED") {
    const message = (typeof data?.body?.error === "string" && data.body.error.trim()) ||
      (typeof value === "string" ? value :
      value?.failureReason || value?.message || value?.error) ||
      data?.header?.message || "Inventory request failed.";
    const error = new Error(typeof message === "string" ? message : "Inventory request failed.");
    error.response = response;
    throw withApiErrorResponse(error);
  }
  return data;
};

// Header-only variant for calls whose body legitimately carries partial results or
// per-row failures (bulk save, sheet upload ack): only a non-600 envelope code -- e.g.
// 608 "Access Denied", which arrives with HTTP 200 -- is turned into an error.
export const checkedEnvelope = (response) => {
  const data = response.data;
  if (data?.header?.code != null && Number(data.header.code) !== 600) {
    const value = data?.body?.value;
    const message =
      (typeof data?.body?.error === "string" && data.body.error.trim()) ||
      (typeof value === "string" ? value : value?.message) ||
      data?.header?.message ||
      "Inventory request failed.";
    const error = new Error(message);
    error.response = response;
    throw withApiErrorResponse(error);
  }
  return data;
};
